// Lib
import React, { ReactElement, useEffect } from 'react';
import { connect } from 'react-redux';

// Actions
import { fetchBoard } from '../element/board/boardService';

// Components
import PageLoaderMain from '../components/loaders/PageLoaderMain';

const mapDispatchToProps = (dispatch: Function) => ({
    dispatchForceFetchBoard: (boardId: string) => dispatch(fetchBoard({ boardId, force: true })),
});

type BoardHierarchyErrorProps = {
    currentBoardId: string;
    dispatchForceFetchBoard: (boardId: string) => void;
};

/**
 * This component is used to force-fetch the current board when there's a hierarchy error
 * (such as the board being deleted or having access denied).
 *
 * This is so that the error gets either confirmed on the server or resolved in the response.
 */
const BoardHierarchyError = (props: BoardHierarchyErrorProps): ReactElement => {
    const { currentBoardId, dispatchForceFetchBoard } = props;

    useEffect(() => {
        if (!currentBoardId) return;

        dispatchForceFetchBoard(currentBoardId);
    }, []);

    return <PageLoaderMain />;
};

export default connect(null, mapDispatchToProps)(BoardHierarchyError);
